import { Box, BoxProps, Stack, Skeleton } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Email, Image, ImageContainer, Paragraph, SignOutButton, User, UserCard } from './styles'

interface ISignOutProps extends BoxProps {
  customerColor: string
  provider?: string
  email?: string | null
  photoURL?: string | null
  displayName?: string | null
  onSignOutClick: () => void
}

const SignOut: FC<ISignOutProps> = ({
  customerColor,
  provider,
  displayName,
  email,
  photoURL,
  onSignOutClick,
  ...boxProps
}) => {
  const { t } = useTranslation()

  return (
    <Box {...boxProps}>
      <Box display="flex" justifyContent="space-between" marginBottom={2}>
        <Paragraph>
          {provider ? `${t('*.account')} ${provider} ${t('*.connected')}` : <Skeleton variant="text" width={180} />}
        </Paragraph>
        <SignOutButton
          size="small"
          customercolor={customerColor}
          style={{ textTransform: 'lowercase' }}
          onClick={onSignOutClick}
        >
          {t('button.disconnect')}
        </SignOutButton>
      </Box>
      <UserCard>
        <Box display="flex" p={2}>
          <ImageContainer>
            {photoURL ? (
              <Image loading="lazy" alt="user avatar" src={photoURL || ''} />
            ) : (
              <Skeleton variant="circular" height="100%" width="100%" />
            )}
          </ImageContainer>

          <Stack paddingLeft={2}>
            <User>{displayName || <Skeleton variant="text" width={120} />}</User>
            <Email>{email || <Skeleton variant="text" width={160} />}</Email>
          </Stack>
        </Box>
      </UserCard>
    </Box>
  )
}

export default SignOut
